<template>
    <div class="sidebar-left">
        <div class="custom-field">
            <el-button class="custom-full-width-btn" type="success" @click="openModal">{{ $t('Create_OF') }}</el-button>
        </div>
        <el-upload action="undefined" class="custom-field">
            <el-button class="custom-full-width-btn" type="warning">{{ $t('import_of') }}</el-button>
        </el-upload>
        <el-input v-model="userSearch" @focus="openFilter" placeholder="Search"></el-input>
        <div v-if="favSearchList !== null && favSearchList.length > 0">
            <collapse :title="'Mes favoris'">
                <el-button size="mini" @click="clearfilter" plain>Effacer le filtre</el-button>
                <ul>
                    <li class="fav-item" v-for="(fav, idx) in favSearchList" :key="idx" @click="setFavFilterSearch(fav)">{{ fav.name }}</li>
                </ul>
            </collapse>
        </div>
        <!-- <div v-if="favSearchList !== null && favSearchList.length > 0">
            <h4>Mes favoris</h4>
            <el-button size="mini" @click="clearfilter" plain>Effacer le filtre</el-button>
            <ul>
                <li class="fav-item" v-for="(fav, idx) in favSearchList" :key="idx" @click="setFavFilterSearch(fav)">{{ fav.name }}</li>
            </ul>
        </div> -->
        <el-divider></el-divider>
        <div>
            <ButtonNav
                :btnText="$t('display_by_manufacturing_order')"
                :routerLink="'home'"
            ></ButtonNav>
            <ButtonNav
                :btnText="$t('display_by_production_area')"
                :routerLink="'production-zone'"
            ></ButtonNav>
            <ButtonNav
                :btnText="$t('display_by_operators')"
                :routerLink="'operators'"
            ></ButtonNav>
            <ButtonNav
                :btnText="$t('display_by_products')"
                :routerLink="'products'"
            ></ButtonNav>
            <ButtonNav
                v-if="isSuperAdmin"
                :btnText="$t('display_beacons')"
                :routerLink="'beacons'"
            ></ButtonNav>
        </div>

        <div v-if="isOnDetailsView">
            <el-divider></el-divider>
            <div class="microcard-collection" >
                <MicroCard v-for="(data, idx) in datasInStore" :key="idx" :type="detailView" :datas="data"></MicroCard>
            </div>
        </div>

        <el-button class="bt-dl-csv" @click="dialogCsv = true" type="success" icon="el-icon-download" plain> TELECHARGER LE CSV</el-button>

        <!-- start Modal for Create OF form -->
        <el-dialog
            width="1200px"
            :visible.sync="dialogFormVisible"
            :modalAppendToBody="false">
                <CreateOfModal :key="dialogFormVisible"></CreateOfModal>
        </el-dialog>
        <!-- end Modal for Create OF form -->
        
        <!-- start Modal for Get CSV -->
        <el-dialog
            width="440px"
            :visible.sync="dialogCsv"
            :modalAppendToBody="false">
                <GetCsv :key="dialogCsv"></GetCsv>
        </el-dialog>
        <!-- end Modal for Get CSV -->

    </div>
</template>

<script>
import CreateOfModal from './of/CreateOfModal.vue'
import ButtonNav from './ButtonNav.vue'
import MicroCard from './MicroCard.vue'
import Collapse from '../components/Collapse.vue'
import GetCsv from '../components/GetCsv.vue'

export default {
    components: {
        CreateOfModal,
        ButtonNav,
        MicroCard,
        Collapse,
        GetCsv
    },
    data() {
        return {
            userSearch: '',
            dialogFormVisible: false,
            openDial: false,
            isOnDetailsView: false,
            detailView: '',
            favoritesList: false,
            dialogCsv: false,
            isSuperAdmin: false
        }
    },
    created() {
        const favSavedLocally = JSON.parse(localStorage.getItem('filterFavorites'));
        this.$store.dispatch('updateSearchFavorites', favSavedLocally);
        this.isSuperAdmin = this.$store.getters.isSuperAdmin;
    },
    computed: {
        favSearchList() {
            return this.$store.getters.searchFavorites;
        },
        datasInStore() {
            if(this.detailView === 'of') {
                return this.$store.getters.manufacturingOrders;
            } else if(this.detailView === 'pz')  {
                return this.$store.getters.productionZones;
            } else if(this.detailView === 'op') {
                return this.$store.getters.operators;
            }
            return [];
        }
    },
    watch: {
        $route (to) {
            if(to.path.split('/').includes('details')) {
                this.isOnDetailsView = true;
                this.detailView = to.path.split('/')[1];
            } else {
                this.isOnDetailsView = false;
                this.detailView = '';
            }
        }
    },
    methods: {
        openCreateOF: function() {
            this.$emit('openCreateOF', true);
        },
        openMyDial: function() {
            this.openDial = true;
        },
        openModal: function() {
            this.dialogFormVisible = true;
        },
        openFilter: function() {
            this.$store.dispatch('switchFilterModalVisible', true);
        },
        setFavFilterSearch: function(fav) {
            this.$store.dispatch('updateSearchFavSelected', fav);
        },
        clearfilter: function() {
            this.$store.dispatch('updateSearchFavSelected', undefined);
        },
        favoritesListChange: function() {
            this.favoritesList = !this.favoritesList; 
        }
    }
}
</script>

<style>
    .sidebar-left {
        height: 100%;
        background-color: var(--color1);
        color: var(--colorText1);
        padding: 30px 12px 12px 12px;
        padding-top: 40px;
    }

    .custom-field {
        margin-bottom: 20px;
        width: 100%;
    }

    .custom-full-width-btn {
        width: 100%;
    }

    .custom-navigation {
        display: flex;
        align-items: center;
    }

    .microcard-collection {
       height: 400px;
       overflow: auto;
    }

    .fav-item {
        list-style: none;
        margin-left: -38px;
    }

    .fav-item:hover {
        cursor: pointer;
        font-weight:bold;
    }

    .bt-dl-csv {
        position: fixed;
        bottom: 10px;
        right: 10px;
        box-shadow: 5px 5px 5px rgba(100,100,100,0.6);
    }

    .orange-btn {
        background-color: var(--btn-color-2);
    }

    .el-upload {
        width: 100%;
    }
</style>